export default __webpack_public_path__ + "static/media/ic_arrowright16.25e0dd13.svg";